(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.csInit === 'true') return;
    root.dataset.csInit = 'true';

    /* Scroll reveal for cards / timeline steps */
    var revealEls = root.querySelectorAll('.cs-reveal, .cs-timeline__step');
    if ('IntersectionObserver' in window && revealEls.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      );
      revealEls.forEach(function (el, i) {
        el.style.transitionDelay = (i % 6) * 60 + 'ms';
        observer.observe(el);
      });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* Consultation form handling */
    var form = root.querySelector('[data-cs-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var valid = true;

        var required = form.querySelectorAll('[required]');
        required.forEach(function (field) {
          if (!field.value || !field.value.trim()) {
            valid = false;
            field.setAttribute('aria-invalid', 'true');
            field.style.borderColor = '#C0392B';
          } else {
            field.removeAttribute('aria-invalid');
            field.style.borderColor = '';
          }
        });

        /* Devices field: optional, but if filled must be a positive whole number */
        var devicesField = form.querySelector('[name="devices"]');
        if (devicesField && devicesField.value.trim() !== '') {
          var devicesNum = Number(devicesField.value);
          if (!Number.isFinite(devicesNum) || !Number.isInteger(devicesNum) || devicesNum <= 0) {
            valid = false;
            devicesField.setAttribute('aria-invalid', 'true');
            devicesField.style.borderColor = '#C0392B';
          } else {
            devicesField.removeAttribute('aria-invalid');
            devicesField.style.borderColor = '';
          }
        }

        if (!valid) {
          var firstInvalid = form.querySelector('[aria-invalid="true"]');
          if (firstInvalid) firstInvalid.focus();
          return;
        }

        var successEl = root.querySelector('[data-cs-success]');
        if (successEl) {
          successEl.classList.add('is-visible');
          successEl.setAttribute('role', 'status');
          successEl.focus && successEl.focus();
        }
        form.reset();
      });

      form.addEventListener('keydown', function (e) {
        if (e.target.name === 'devices' && ['-', '+', 'e', 'E', '.'].indexOf(e.key) !== -1) {
          e.preventDefault();
        }
      });

      form.addEventListener('input', function (e) {
        if (e.target.name === 'devices') {
          var num = Number(e.target.value);
          var ok = e.target.value.trim() === '' || (Number.isFinite(num) && Number.isInteger(num) && num > 0);
          if (ok) {
            e.target.removeAttribute('aria-invalid');
            e.target.style.borderColor = '';
          }
          return;
        }
        if (e.target.hasAttribute('required') && e.target.value.trim()) {
          e.target.removeAttribute('aria-invalid');
          e.target.style.borderColor = '';
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-cs-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init when a new section instance is added via Theme Editor */
  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target.querySelector('[data-cs-section]');
    if (root) initSection(root);
  });
})();
